import { useState, useEffect } from "react";
import qs from "qs";
import styled from "styled-components";

import loadingImg from "images/lottiefile/yellow_loading_animation.json";
import {
  PaybackItemBlock,
  Period,
  PaybackItemBtn,
} from "components/presenters/commerce/payback/PaybackItem";
import EmptyPayback from "components/presenters/commerce/payback/EmptyPayback";
import LottieLoader from "components/containers/common/LottieLoader";
import OrderItem from "components/presenters/commerce/order/OrderItem";
import SplitterBar from "components/presenters/common/SplitterBar";
import server from "server/serverController2";
import { differenceInDays } from "date-fns";
import { getDateByTimezone } from "utils/utils";

export default function Payback() {
  const [attendees, setAttendees] = useState([]);
  const [isEnd, setIsEnd] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [lastPosNo, setLastPosNo] = useState(null);

  useEffect(() => {
    loadData();
    updatePaybackUnread();
  }, []);

  const updatePaybackUnread = () => {
    let form = {};
    form["unread_num"] = 0;
    server.putRequestData(`users/commerce/paybacks/unread`, form, (res) => {
      try {
        if (res.success !== 1) {
          return;
        }
      } catch (err) {
        console.log(err);
      }
    });
  };
  const loadData = () => {
    if (!isLoading && !isEnd) {
      setIsLoading(true);
      const currDate = getDateByTimezone("Asia/Seoul");
      let form = {};
      form["get_attendee_auth"] = true;
      form["get_tasks"] = true;
      form["get_order_item"] = true;
      form["get_payback"] = true;
      form["last_pos_no"] = lastPosNo;
      form["start_date_le"] = currDate;
      form["limit"] = 20;
      let queryString = qs.stringify(form);

      server.getRequestData(
        `users/commerce/challenges/attendees?${queryString}`,
        (res) => {
          try {
            if (res.success !== 1) {
              return;
            }
            let jsonData = res.data;
            let attendeeList = jsonData.attendees;
            console.log(attendeeList);
            if (attendeeList.length < 20) {
              setIsEnd(true);
            }

            if (attendeeList.length > 0) {
              setLastPosNo(attendeeList[attendeeList.length - 1]["no"]);
              setAttendees([...attendees, ...attendeeList]);
            }

            setIsLoading(false);
          } catch (err) {
            console.log(err);
            setIsLoading(false);
          }
        }
      );
    }
  };
  const handleScroll = (e) => {
    const bottom =
      e.target.scrollHeight - e.target.scrollTop - 100 <= e.target.clientHeight;
    if (bottom && !isEnd) {
      if (!isLoading) {
        setIsLoading(true);
        loadData();
      }
    }
  };
  return attendees.length > 0 ? (
    <Section onScroll={handleScroll}>
      {attendees.map((attendee, index) => {
        const authDataList = attendee?.auths;
        let remainedAuthNum = 0;
        if (Array.isArray(authDataList) && authDataList.length > 0) {
          for (let i = 0; i < authDataList.length; ++i) {
            if (authDataList[i]["min_auth"] > authDataList[i]["curr_auth"]) {
              remainedAuthNum +=
                authDataList[i]["min_auth"] - authDataList[i]["curr_auth"];
            }
          }
        }

        let currDate = getDateByTimezone("Asia/Seoul", new Date());
        let endDate = getDateByTimezone(
          "Asia/Seoul",
          new Date(attendee["end_date"])
        );
        let isFail = false;
        if (
          differenceInDays(new Date(endDate), new Date(currDate)) + 1 <
          remainedAuthNum
        ) {
          isFail = true;
        }

        const orderItem = attendee?.order_item;
        const product = attendee?.order_item?.product;
        const isPaybackProcessed = attendee?.payback?.is_processed
        const variantOptions = attendee?.order_item?.variant_options;
        let variantName = [];
        if (variantOptions) {
          for (let i = 0; i < variantOptions.length; ++i) {
            variantName.push(variantOptions[i]["name"]);
          }
        }
        variantName.join("/"); 
        return (
          <PaybackItemBlock key={`payback-item-no-${attendee["no"]}`}>
            <Period endDate={new Date(attendee["end_date"])} />
            <OrderItem
              bannerImg={product?.banner_img}
              unitPrice={orderItem?.unit_price}
              challengeUnitPrice={orderItem?.challenge_unit_price}
              optionName={variantName.join("/")}
              quantity={orderItem?.quantity}
              isChallenge={orderItem.is_challenge}
              title={product?.title}
            />
            <PaybackItemBtn
              isFail={isFail}
              isProcessed={isPaybackProcessed}
              remainedAuthNum={remainedAuthNum}
            />
            {index !== attendees.length - 1 && (
              <SplitterBar
                color={"#EFEFEF"}
                margin={`0 0 calc(100vw * (30 / 375)) 0`}
              />
            )}
          </PaybackItemBlock>
        );
      })}
      {!isEnd && (
        <LoadingWrapper>
          <LottieLoader
            lottieOptions={{
              loop: true,
              autoplay: true,
              renderer: "svg",
              animationData: loadingImg,
            }}
            style={{
              position: "absolute",
              top: "0",
              bottom: "0",
              left: "0",
              right: "0",
            }}
          />
        </LoadingWrapper>
      )}
    </Section>
  ) : (
    <EmptyPayback />
  );
}
const Section = styled.div`
  height: 100%;
  overflow-y: scroll;
`;
export const LoadingWrapper = styled.div`
  position: relative;
  height: calc(100vw * (35 / 375));
  width: 100%;
  margin-top: calc(100vw * (10 / 375));
`;
